// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2XeeC","label":"Completed_label__2g_h6"};